import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	header: {
		id: 'admin-pages-issue-types-directory.table.error-state.header',
		defaultMessage: 'An error occurred',
		description: 'Empty state message header',
	},
	description: {
		id: 'admin-pages-issue-types-directory.table.error-state.description',
		defaultMessage: 'There was a problem loading your issue types.',
		description: 'Error state message description',
	},
});
